import React, { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import CardSkeleton from '@/app/common/components/skeleton/CardSkeleton';
import LineTimeChart from '@/app/common/components/LineTimeChart';
import { useLazyGetCompetitorsAvgRankChartQuery } from '@/app/KeywordTracker/api/keywordsApi';
import { getColor, getRandomColor } from '@/helpers/utils';
import { hideDrawer } from '@/app/common/reducers/drawer';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import useDomain from '@/hooks/useDomain';


const CompetitorRankDrawer = () => {
  const [chartData, setChartData] = useState(null);
  const dispatch = useDispatch();
  const { key, payload } = useSelector(state => state.drawer);
  const { keyword_id, keyword } = payload ?? '';
  const { domain, domain_slug } = useDomain();
  const [getData] = useLazyGetCompetitorsAvgRankChartQuery();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (keyword && keyword_id) {
      getData({
        from_date: Number(searchParams.get('from_date')),
        to_date: Number(searchParams.get('to_date')),
        domain_slug,
        keyword_id
      })
        .unwrap()
        .then(res => {
          setChartData(res);
        });
    }

    return () => {
      setChartData(null);
    };
  }, [keyword_id, keyword]);


  const formattedSeries = chartData =>
    Object.entries(chartData?.data?.competitors)?.map(([name, value], i) => {
      const c = getRandomColor(i);
      return {
        type: 'line',
        smooth: false,
        name,
        data: value,
        symbol: 'emptyCircle',
        itemStyle: {
          color: getColor(c)
        },
        lineStyle: {
          color: getColor(c)
        },

        emphasis: {
          lineStyle: {
            width: 2
          }
        }
      };
  });

  return (
    <DrawerWrapper
      show={key === 'competitors_rank'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0 fw-light">
            نمودار روند رتبه رقیب&nbsp;
            <span className="fw-bolder">
              ( {keyword ? decodeURIComponent(keyword) : ''} )
            </span>
          </h6>
        </div>
      }
    >
      <div className="mt-3">
        {chartData ? (
          <LineTimeChart
            showName
            showLegent
            isInversed
            series={formattedSeries(chartData)}
            topLabel="روند رتبه"
            dates={chartData?.data?.dates}
          />
        ) : (
          <CardSkeleton />
        )}
      </div>
    </DrawerWrapper>
  );
};

export default CompetitorRankDrawer;
